module.exports = __webpack_public_path__ + "img/cabernet-syrah.218369f2.jpg";